﻿import {withCapitalized} from "../../../../hocs/withCapitalized";
import {CardItemLabelWithGray} from "./CardItemLabelWithGray";

export const CardItemLabelWithGrayCapitalized = withCapitalized(CardItemLabelWithGray);
